import { createSlice } from '@reduxjs/toolkit'
import { MetricsServerState } from './types'

export const initialMetricsServerState: MetricsServerState = {
  metricsServerState: {
    seatConfiguration: {
      total: 0,
      ball: 0,
      playerTag: 0,
      anchor: 0,
      lowPower: 0
    },
    config: {
      LocationName: '',
      Algorithms: {
        EnableBallInPlay: false,
        SeatSwapping: {
          Enabled: false
        }
      },
      GeniusIntegration: false
    },
    connectionState: 'Unknown',
    msVersion: '',
    daemonVersion: '',
    type: 'Everything',
    authState: {
      authState: 'Unknown',
      hasToken: false,
      nextTokenRefresh: '',
      message: '',
      laptop: {
        name: '',
        organisation: {
          name: '',
          id: ''
        },
        region: '',
        environment: ''
      }
    },
    msg: ''
  }
}

export const metricsServerSlice = createSlice({
  name: 'metricsServer',
  initialState: initialMetricsServerState,
  reducers: {
    setMetricsServerState: (
      state,
      action: { payload: Partial<MetricsServerState['metricsServerState']> }
    ) => {
      state.metricsServerState = {
        ...state.metricsServerState,
        ...action.payload
      }
    }
  }
})

export const reducer = metricsServerSlice.reducer

export const { setMetricsServerState } = metricsServerSlice.actions
